module.exports = __webpack_public_path__ + "statics/img/manuals.f7d6e00e.svg";